import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import useQuery from 'hooks/useQuery'
import { filterEmptyValues } from 'utils/helpers'
import { Button, TextInput } from 'components/common'
import { PRICE_LABEL_FORM_FIELDS } from './utils'

const { STORE_ID, BARCODE } = PRICE_LABEL_FORM_FIELDS

type Props = {
  toggleFilterForm: () => void
}

export const FILTER_FIELD_PRICE_LABEL = 'priceLabelFilters'

const PriceLabelFilterForm = ({ toggleFilterForm }: Props) => {
  const { getQuery, removeQuery, setMultipleQueries } = useQuery()
  const filters = getQuery(FILTER_FIELD_PRICE_LABEL)
  const { register, handleSubmit, reset } = useForm({
    defaultValues: filters,
  })
  const [, setResetFilter] = useState(false)

  const onFilterApply = (data: any) => {
    if (data?.status === 'NONE') delete data.status

    const filteredData = filterEmptyValues(data)

    if (Object.values(filteredData).length > 0) {
      setMultipleQueries({ [FILTER_FIELD_PRICE_LABEL]: filteredData, page: 1 })
    } else {
      removeQuery(FILTER_FIELD_PRICE_LABEL)
    }

    toggleFilterForm()
  }

  const cancelFilter = () => {
    reset(filters)
    setResetFilter((prev) => !prev)
    toggleFilterForm()
  }

  useEffect(() => {
    reset(filters)
  }, [])

  return (
    <div className="mt-2 rounded-lg border bg-white px-5 py-3">
      <div className="mx-auto max-w-5xl">
        <form onSubmit={handleSubmit(onFilterApply)}>
          <div className="grid grid-cols-2 gap-x-14 gap-y-3 md:grid-cols-3">
            {/* Store ID */}
            <TextInput
              register={register}
              name={STORE_ID.key}
              label={STORE_ID.label}
            />

            {/* Barcode */}
            <TextInput
              register={register}
              name={BARCODE.key}
              label={BARCODE.label}
            />
          </div>

          <div className="my-4 flex gap-5">
            <Button buttonText="Apply Filters" className="w-32" />
            <Button
              type="button"
              buttonText="Cancel"
              variant="outline"
              onClick={cancelFilter}
              className="w-32"
            />
          </div>
        </form>
      </div>
    </div>
  )
}

export default PriceLabelFilterForm
